import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { ApplicantService } from '../../services/applicant.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { JobOffersService } from '../../services/job-offers.service';
import { InviteService } from '../../services/invite.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { OfferStore } from '../state/offer.store';
import { Constants } from '../constants';

@Component({
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styleUrls: ['./kanban.component.css']
})
export class KanbanComponent implements OnInit {

   @Input() listPending;
  @Input() listCustom;
  @Input() applyListStatus;
  @Input() job;
  @Input() showInvite;

  @Output() out: EventEmitter<number> = new EventEmitter<number>();

  check_mandatory: string;
  check_invite: string;

  publicating = false;
  errorMessage: string;

  apply_status: any[];

  public STATUS = Constants;

  constructor(public applicantService: ApplicantService,
    public applyStatusService: ApplyStatusService,
    private dialog: MdDialog,
    private jobService: JobOffersService,
    private inviteService: InviteService) {
    this.check_mandatory = 'true';
    this.check_invite = 'Todas';
  }

  ngOnInit() {
  }

  filterItemsOfStatus(list, status){
    if (list) {
      if (status != 'Todas') {
        return list.filter(x => x.status == status);
      } else {
        return list.filter(x => x);
      }
    } else {
      return undefined;
    }
  }

  onDropSuccess($event: any, status_id: number) {
    $event.feedback = 0;

    if ($event.status.id == 300){
      this.job.users_selected =  parseInt(this.job.users_selected) -1;
      this.out.emit(this.job.users_selected);
      if(this.job.users_selected < 0 ){
        this.job.users_selected = 0;
      }
      //this.jobService.publish(this.job);
    }
    if (status_id == 300){
      this.job.users_selected = parseInt(this.job.users_selected) +1;
      this.out.emit(this.job.users_selected);
      //this.jobService.publish(this.job);
    }
    if (status_id == 100){
      this.putApplicantStatus($event.job.id, $event.user_id, 0, $event.feedback);
      $event.status.id = 0;
    }else{
      this.putApplicantStatus($event.job.id, $event.user_id, status_id, $event.feedback);
      $event.status.id = status_id;
    }
  }

  onDragSuccess($event: any) {
    //this.putApplicantStatus($event.job.id, $event.user_id, status_id);
    //$event.status.id = status_id;
  }

   onDropSuccessInvite($event: any) {
     if ($event.status_invited === false) {
       this.onPostInvite($event.job.id, $event.user_id);
    } else {
       this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: 'El candidato ' + $event.email + ' ya fue invitado', alert: true, showIcon: true}});
       this.listPending.splice(this.listPending.indexOf($event), 1);
       if ($event.status.id === this.STATUS.STATUS_PRESELECTED) {
           //this.listPreselected.offersNonObservable.unshift($event);
       } else if ($event.status.id === this.STATUS.STATUS_REJECTED) {
          // this.listRejected.offersNonObservable.unshift($event);
       } else if ($event.status.id === this.STATUS.STATUS_SELECTED ) {
            // this.listHired.offersNonObservable.unshift($event);
       } else {
         if ($event.mandatoryrequirements > 0 && $event.mandatoryrequirements === $event.mandatoryrequirementsmet) {
           //this.listPostuledReq.offersNonObservable.unshift($event);
         } else {
           //this.listPostuledNotReq.offersNonObservable.unshift($event);
         }
       }
     }
   }

  putApplicantStatus (job_id:string , user_id: string, status_id: number, feedback: number) {
    const role = localStorage.getItem('role');
    if (role === 'contracts') {
      this.applicantService.putApplicantContract(job_id, user_id, status_id, feedback).subscribe(
        data => {
        },
        error => {
          console.log (error);
        }
      );
    }else {
      this.applicantService.putApplicantStatus(job_id, user_id, status_id, feedback).subscribe(
        data => {
        },
        error => {
          console.log (error);
        }
      );
    }

  }

  onPostInvite(job_id, user_id) {

    const invitations = [{
        'job_id': job_id,
        'user_id': user_id
    }];

    this.inviteService.postInvite(invitations)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors: string = error;
          let jsonErrors: any =  [];
          jsonErrors =  JSON.parse(txterrors).errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                }
                txterrors = txterrors+"<p class='bg-danger'>"+element.row+" ("+txterr+")</p>";
                //txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>";
            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>";
          }
          this.publicating = false;
          this.errorMessage = <any>error;
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
  }

  goToHelpReport(){
    this.dialog.open(MessageBoxDialog, {data: {message: 'Para generar informes debes mover los candidatos a la columna "generar informes" automáticamente el sistema te mostrará el nivel de cumplimiento de los requisitos obligatorios, deseables y las pruebas por competencias de los candidatos (si se realizaron) y podrás anexar información adicional del proceso.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/kanban/kanban.component.ts